<!--
 * @Description: 登录
 * @Author: huangshiwen
 * @Date: 2022-05-30 13:40:58
 * @LastEditTime: 2022-06-08 16:02:17
-->
<template>
    <SzhospitalEnroll />
</template>

<script>
import SzhospitalEnroll from "@/components/hospitalEnroll/szhospitalEnroll"
export default{
  components:{
    SzhospitalEnroll
  },
  
  data(){
    return {

    }
  },
  created(){

  }
}
</script>
<style lang="less" scoped>

</style>